import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class SuccessMessageService {
  private readonly hideDelay = 10000

  #message = signal<string | null>(null)
  message = this.#message.asReadonly()

  handleSuccess(message: string | null) {
    this.#message.set(message)
    setTimeout(() => this.#message.set(null), this.hideDelay)
  }
}
